import React from 'react';
import Loader from '../../components/common/Loader';
import Footer from '../../components/common/Footer';
import Menu from '../../components/common/Menu';
import Navbar from '../../components/common/Navbar';
import StartButton from '../../components/home/StartButton';
import FloatingCheckoutButton from '../../components/common/FloatingCheckoutButton';
import Header from '../../components/innerpage/contact/Header';
import ContactForm from '../../components/innerpage/contact/ContactForm';
import {Helmet} from 'react-helmet';
import { usePageLoader } from '../../hooks/usePageLoader';

const ContactPage: React.FC = () => {
    usePageLoader(); // Hide loader on mount for client-side navigation

    return (
        <>
            <Helmet>
                <link rel="canonical" href="https://tempefab.com/contact"/>
                <title>Metal Fabrication Phoenix AZ | Custom Railings, Gates & Metalwork | Tempe Fabrication | Contact Us</title>
                <meta name="description"
                      content="Professional metal fabrication services in Tempe, Arizona. Custom railings, gates, furniture, signs, and architectural metalwork. Licensed contractor AZROC #359773. Get a free quote today. Contact us. Email us. Contact information."/>
                <link
                    rel="stylesheet"
                    type="text/css"
                    href="/home/assets/css/home_1_style.css"
                />
                <link
                    rel="stylesheet"
                    type="text/css"
                    href="/innerpages/assets/css/innerpages.css"
                />
                <script src="/common/assets/js/common_js.js"></script>
                <script src="/innerpages/assets/js/innerpages.js"></script>
            </Helmet>
            <div className="inner-pages-style1 contact-pg-style1">
            <Loader/>
            <Menu/>
            <div className="smooth-scroll-content" id="scrollsmoother-container">
                <Navbar currentPage="contact"/>
                <Header/>

                <main>
                    <ContactForm/>
                </main>
                <Footer/>
            </div>
            <StartButton/>
            <FloatingCheckoutButton/>
            </div>
        </>
    );
}

export default ContactPage;
